var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.read_only)?_c('div',[_c('h2',{staticClass:"dark-orange--text font30 p-flex"},[_vm._v("SPCI")]),_c('form_item',{attrs:{"selectedItem":_vm.selectedItem,"read_only":_vm.read_only}})],1):_c('w',{attrs:{"selectedItem":_vm.selectedItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }